import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getReportPermissions,
  hasReportRouteAccess,
} from "../../../utils/permissions";

const REPORT_LINKS = [
  {
    to: "/report/salesBreakdownByTime",
    label: "Sales Performance by Time",
    kind: "marketplaceSale",
  },
  { to: "/report/salesByProducts", label: "Sales by Products", kind: "marketplaceSale" },
  {
    to: "/report/purchaseSupplierReport",
    label: "Item Purchase Report",
    kind: "general",
  },
  { to: "/report/dealPerformance", label: "Deal Performance Report", kind: "marketplaceSale" },
  {
    to: "/report/requisitionReport",
    label: "Requisition Report",
    kind: "general",
  },
  { to: "/report/tableSpent", label: "Table Spent Report", kind: "sale" },
  { to: "/report/customerReport", label: "Customer Report", kind: "general" },
  { to: "/report/riderReport", label: "Rider Report", kind: "general" },
  {
    to: "/report/pettyFloatCashReport",
    label: "Petty and Float Cash Report",
    kind: "general",
  },
  {
    to: "/report/staffActivityLogReport",
    label: "Staff Activity Log Report",
    kind: "general",
  },
  { to: "/report/zReport", label: "Z-Report (Day Closing Report)", kind: "sale" },
];

const ReportManagementSidebar = () => {
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const authProfileData = useSelector((state) => state.auth.profileData);
  const userForPerms =
    user && authProfileData && !user.profileData
      ? { ...user, profileData: authProfileData }
      : user;

  const reportPermissions = getReportPermissions(userForPerms);
  const visibleLinks = REPORT_LINKS.filter((link) => {
    if (link.kind === "marketplaceSale" && !reportPermissions.isAllowedMarketplaceSaleReport) {
      return false;
    }
    if (link.kind === "sale" && !reportPermissions.isAllowedSaleReport) return false;
    if (link.kind === "general" && !reportPermissions.isAllowedGeneralReport) return false;
    // Same gate as PrivateRoute — hide anything the company/role cannot open
    return hasReportRouteAccess(userForPerms, link.to);
  });

  const currentPath = location.pathname.toLowerCase();
  // Stock Overview / Stock Adjustments live under Inventory Management now
  const movedToInventoryPaths = [
    "/report/masterinventoryreport",
    "/report/reconciliationreport",
  ];
  // Go Fatafat reports live under the Go Fatafat nav
  const movedToGoFatafatPaths = [
    "/report/restaurantperformance",
    "/report/marketplaceorderearningsreport",
    "/report/marketplacesettlementreport",
  ];
  const isMovedInventoryReport = movedToInventoryPaths.some((p) =>
    currentPath.startsWith(p)
  );
  const isMovedGoFatafatReport = movedToGoFatafatPaths.some((p) =>
    currentPath.startsWith(p)
  );
  const isReportActive =
    currentPath.startsWith("/report") &&
    !isMovedInventoryReport &&
    !isMovedGoFatafatReport;

  if (!reportPermissions.canAccessReports || visibleLinks.length === 0) {
    return null;
  }

  return (
    <div className={`menu-item has-sub ${isReportActive ? "active" : ""}`}>
      <div className="menu-link">
        <div className="menu-icon">
          <i className="fa-solid fa-user-tie"></i>
        </div>
        <div className="menu-text">Report </div>
        <div className="menu-caret"></div>
      </div>
      <div className="menu-submenu">
        {visibleLinks.map((link) => (
          <div
            key={link.to}
            className={`menu-item ${location.pathname.startsWith(link.to) ? "active" : ""}`}
          >
            <NavLink to={link.to} className="menu-link">
              {link.label}
            </NavLink>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportManagementSidebar;
